import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeNestMulti = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M15.4893 3C14.6608 3 13.9893 3.67157 13.9893 4.5V9.5C13.9893 10.3284 14.6608 11 15.4893 11H20.4893C21.3177 11 21.9893 10.3284 21.9893 9.5V4.5C21.9893 3.67157 21.3177 3 20.4893 3H15.4893Z" />
    <path d="M15.4893 13C14.6608 13 13.9893 13.6716 13.9893 14.5V19.5C13.9893 20.3284 14.6608 21 15.4893 21H20.4893C21.3177 21 21.9893 20.3284 21.9893 19.5V14.5C21.9893 13.6716 21.3177 13 20.4893 13H15.4893Z" />
    <path d="M3.98926 14.5C3.98926 13.6716 4.66083 13 5.48926 13H10.4893C11.3177 13 11.9893 13.6716 11.9893 14.5V19.5C11.9893 20.3284 11.3177 21 10.4893 21H5.48926C4.66083 21 3.98926 20.3284 3.98926 19.5V14.5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.98926 4.5C3.98926 3.67157 4.66083 3 5.48926 3H10.4893C11.3177 3 11.9893 3.67157 11.9893 4.5V9.5C11.9893 10.3284 11.3177 11 10.4893 11H5.48926C4.66083 11 3.98926 10.3284 3.98926 9.5V4.5ZM5.98926 9V5H9.98926V9H5.98926Z"
    />
  </SvgIcon>
));

TypeNestMulti.displayName = 'TypeNestMulti';

export default TypeNestMulti;
